import styled from 'styled-components';

const slotStyles = (slot, size) => {
  const inactiveWidth = size * 0.6;
  const inactiveHeight = size * 0.3;
  const gap = size * 0.075;
  const activeWidth = inactiveWidth * 2 + gap;

  switch (slot) {
    case 0:
      return `
        top: 0px;
        left: 0px;
        width: ${activeWidth}px;
        height: ${size}px;
        filter: brightness(1);
      `;
    case 1:
      return `
        top: ${size + gap}px;
        left: 0px;
        width: ${inactiveWidth}px;
        height: ${inactiveHeight}px;
        filter: brightness(0.65);
      `;
    case 2:
      return `
        top: ${size + gap}px;
        left: ${inactiveWidth + gap}px;
        width: ${inactiveWidth}px;
        height: ${inactiveHeight}px;
        filter: brightness(0.65);
      `;
    default:
      return '';
  }
};

export const StoplightContainer = styled.div`
  position: relative;
  width: ${(props) => props.$size * 1.275}px;
  height: ${(props) => props.$size * 1.375}px;
  flex-shrink: 0;
`;

export const StoplightSquare = styled.div`
  position: absolute;
  /* border-radius: ${(props) => props.theme.borderRadius}; */
  border-radius: 5px;
  background-color: ${(props) =>
    props.theme[props.$color] || props.theme.disabledColor};

  transition:
    top 0.4s ease-in-out,
    left 0.4s ease-in-out,
    width 0.4s ease-in-out,
    height 0.4s ease-in-out,
    filter 0.4s ease-in-out;

  ${(props) => slotStyles(props.$slot, props.$size)}
`;
